import { httpGet, httpPost } from 'core/utils/httpClient';
import { StoreTrack, UrlScrapper } from '../models/api';

export const solveRecaptcha = (params: {
  token: string;
}): Promise<{ status: 'success' | 'failure'; message: string }> =>
  httpGet('/auth/solve-recaptcha', params);

export const spamCheck = (token?: string): Promise<unknown> => {
  if (token) return httpGet('/auth/spam-check', { token });
  return httpGet('/auth/spam-check');
};

export const storeTrack = (data: StoreTrack): Promise<unknown> =>
  httpPost('/standard/storeAction', data);

export const scrapeArticleFromURL = (data: UrlScrapper): Promise<{ text: string }> =>
  httpPost('/system/scrape', data);

// Youtube captions
export const scrapeCaptionsFromYoutube = (vID: string): Promise<unknown> => {
  const params = { vID };
  return httpGet('/utils/youtube-captions', params);
};

export const sentenceSplitter = (
  data: {
    text: string;
  },
  fallback?: boolean,
  timeout?: number
): Promise<any> => {
  const payload = { text: data.text, fallback, timeout };
  return httpPost('/utils/sentence-spiltter', payload);
};

export const recommendedWords = (text: string): Promise<any> =>
  httpPost('/utils/keyword', { text });

export const extractKeywords = (text: string): Promise<any> =>
  httpPost('/utils/extract-keyword', { text });
